export default {"src":"/_next/static/media/globe.0b34fb30.svg","height":28,"width":28};